import { Storybook } from "@tento-ui/ui/storybook";
import { TurnAttachment } from "./attachment";

/** A chip is only ever seen next to other chips, so the cluster card is
 * the one that matters: even heights, one left edge, and four kinds a
 * reader can tell apart without reading a word. */
export class TurnAttachmentStoryBook extends Storybook.Default {
  title(): string {
    return "Turn · attachment";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "The cluster — what a turn's output actually looks like",
        render: () => {
          const $wrap = cluster();
          $wrap.append(
            TurnAttachment.makeWith({
              label: "tento-ui-js/components/turn/note.ts",
              kind: "file",
              meta: "+184",
            }),
            TurnAttachment.makeWith({
              label: "shot-plan-round8.png",
              kind: "image",
              meta: "1100×1400",
            }),
            TurnAttachment.makeWith({
              label: "agentclientprotocol.com/protocol/v1/overview",
              kind: "link",
              onOpen: () => {},
            }),
            TurnAttachment.makeWith({
              label: "out/news-summary-2026-08-06.md",
              kind: "artifact",
              meta: "news.summary/v1",
              onOpen: () => {},
            }),
            TurnAttachment.makeWith({ label: "README.md", kind: "file" }),
          );
          return $wrap;
        },
      },
      {
        title: "The four kinds, alone — tile colour before glyph",
        render: () => {
          const $wrap = cluster();
          $wrap.append(
            TurnAttachment.makeWith({ label: "main.rs", kind: "file" }),
            TurnAttachment.makeWith({ label: "diagram.png", kind: "image" }),
            TurnAttachment.makeWith({ label: "openai.com/docs", kind: "link" }),
            TurnAttachment.makeWith({ label: "report.md", kind: "artifact" }),
          );
          return $wrap;
        },
      },
      {
        title: "Openable and not — identical at rest; hover the first one",
        render: () => {
          const $wrap = cluster();
          $wrap.append(
            TurnAttachment.makeWith({
              label: "out/news-summary.md",
              kind: "artifact",
              onOpen: () => {},
            }),
            TurnAttachment.makeWith({
              label: "out/news-summary.md",
              kind: "artifact",
            }),
          );
          return $wrap;
        },
      },
      {
        title: "Long paths cap, and truncate from the head — the tail names it",
        render: () => {
          const $wrap = cluster();
          $wrap.append(
            TurnAttachment.makeWith({
              label:
                "/Users/james/workspace/tento/tento-node-registry/tento-spool.node/target/local.web/routes/index.root.js",
              kind: "file",
              meta: "391 kB",
            }),
            TurnAttachment.makeWith({
              label:
                "/Users/james/workspace/tento/tento-ui-js/components/turn/attachment.ts",
              kind: "file",
              meta: "127 lines",
            }),
          );
          return $wrap;
        },
      },
    ];
  }
}

/** What the caller is expected to do with a set of these: a wrapped row,
 * not a stack. The chip promises to be an even size inside one. */
function cluster(): HTMLElement {
  const $wrap = document.createElement("div");
  $wrap.style.display = "flex";
  $wrap.style.flexWrap = "wrap";
  $wrap.style.gap = "6px";
  $wrap.style.width = "100%";
  return $wrap;
}
